import {
    profileOfferActivatePremiumRoute,
    profilePremiumPackageCheckoutRoute,
} from '../../models/routes';
import { csrfTokenHeader } from '../../services/CsrfTokenService';
import { Offer, PremiumSummary } from '../../types';

const parseErrorMessage = async (response: Response) => {
    const payload = await response.json().catch(() => null);

    return (
        payload?.errors?.base ||
        payload?.errors?.general ||
        'Сталася помилка. Спробуйте ще раз.'
    );
};

export const createPremiumCheckout = async (serviceId: number) => {
    const response = await fetch(
        profilePremiumPackageCheckoutRoute(serviceId),
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...csrfTokenHeader(),
            },
        },
    );

    if (!response.ok) {
        throw new Error(await parseErrorMessage(response));
    }

    const payload = await response.json();
    return payload.paymentUrl as string;
};

export const activatePremiumForOffer = async (offerId: number) => {
    const response = await fetch(profileOfferActivatePremiumRoute(offerId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...csrfTokenHeader(),
        },
    });

    if (!response.ok) {
        throw new Error(await parseErrorMessage(response));
    }

    return response.json() as Promise<{
        offer: Offer;
        premiumSummary: PremiumSummary;
    }>;
};
